const getItemUuidsFromList = (list) => {
	const uuidList = [];
	if (!list || !list.length) {
		return [];
	}
	list.forEach((item) => {
		uuidList.push(item.uuid);
	});
	return uuidList;
};

export default getItemUuidsFromList;



// WEBPACK FOOTER //
// ./src/helpers/getItemUuidsFromList.js